import { module } from "angular";
import { tap } from "rxjs/operators";

import type { Observable } from "rxjs";

import type { IConfig } from "App/Modules/Utils";

import type { IHttpService } from "App/Modules/Services";

import type { IAlarmHandling, IResponse } from "../../Models";
import { AlarmClassification } from "../../Models";
import type { IAlarmHandlingRepository } from "./IAlarmHandlingRepository";

export default class AlarmHandlingRepository implements IAlarmHandlingRepository {
    public static $inject: string[] = ["mmHttpService", "irConfig"];

    public static enhanceAlarmHandling(alarmHandling: IAlarmHandling): IAlarmHandling {
        alarmHandling.alarmClassificationName = alarmHandling.alarmClassification as any;
        alarmHandling.alarmClassification = AlarmClassification[alarmHandling.alarmClassificationName];
        return alarmHandling;
    }

    constructor(private readonly httpService: IHttpService, private readonly config: IConfig) {}

    public getImageSrc(alarmId: string, siteEquipmentId: string): string {
        return `${this.config.apiUrl}alarms/${alarmId}/video/${siteEquipmentId}/image`;
    }

    public getMjpegSrc(alarmId: string, siteEquipmentId: string): string {
        return `${this.config.apiUrl}alarms/${alarmId}/video/${siteEquipmentId}/mjpeg`;
    }

    public getAacSrc(alarmId: string, siteEquipmentId: string): string {
        return `${this.config.apiUrl}alarms/${alarmId}/audio/${siteEquipmentId}`;
    }

    public runCameraSequence(alarmId: string, siteEquipmentId: string, sequence: string): Observable<IResponse<void>> {
        return this.httpService.get<void>(`alarms/${alarmId}/video/${siteEquipmentId}/goto/${sequence}`);
    }

    public panTiltCamera(alarmId: string, siteEquipmentId: string, direction: string): Observable<IResponse<void>> {
        return this.httpService.get<void>(`alarms/${alarmId}/video/${siteEquipmentId}/pan/${direction}`);
    }

    public sendSound(alarmId: string, siteEquipmentId: string, data: any): Observable<IResponse<void>> {
        return this.httpService.post<void>(`alarms/${alarmId}/audio/${siteEquipmentId}`, data);
    }

    public patchAlarmHandling(alarmId: string, data: IAlarmHandling): Observable<IResponse<IAlarmHandling>> {
        const patch = { ...data };
        if (patch.alarmClassification !== undefined) {
            patch.alarmClassification = AlarmClassification[patch.alarmClassification] as any;
        }
        return this.httpService
            .patch<IAlarmHandling>(`alarms/${alarmId}/alarmHandling`, patch)
            .pipe(tap((alarmHandling) => AlarmHandlingRepository.enhanceAlarmHandling(alarmHandling.data)));
    }
}

module("mmRepositories").service("mmAlarmHandlingRepository", AlarmHandlingRepository);
